export const defaultHeaders = [
  {
    text: "Наименование",
    sortable: true,
    key: "name",
  },
  {
    text: "Производитель",
    sortable: true,
    key: "manufacturer",
  },
  {
    text: "Остаток",
    sortable: true,
    key: "stock",
  },
  {
    text: "Цена",
    sortable: true,
    key: "price",
  },
  {
    text: "Вид: ",
    sortable: false,
    key: "action",
    items: [
      {
        title: "таблица",
        type: "table",
      },
      {
        title: "список",
        type: "list",
      },
    ],
  },
];

export const defaultFilters = [
  {
    code: "filter_on_sale",
    name: "Распродажа",
  },
  {
    code: "filter_promo",
    name: "Акции",
  },
  {
    code: "filter_available",
    name: "В наличии",
  },
  {
    code: "filter_is_top",
    name: "Топ продаж",
  },
];
